import styled from "styled-components";

export const UnfriendModalButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;
